// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'face-sad';

export const Component = () => (
  <path
    fillRule='evenodd'
    d='M20.63 4.37C22.878 6.614 24 9.31 24 12.5c0 3.19-1.123 5.885-3.37 8.13C18.386 22.878 15.69 24 12.5 24c-3.19 0-5.885-1.123-8.13-3.37C2.122 18.386 1 15.69 1 12.5c0-3.19 1.123-5.885 3.37-8.13C6.614 2.122 9.31 1 12.5 1c3.19 0 5.885 1.123 8.13 3.37ZM10.48 2.033c2.111-.405 4.133-.224 6.11.629a10.945 10.945 0 0 1 4.76 3.907 10.656 10.656 0 0 1 1.753 5.93l-.011.363c-.122 2.765-1.153 5.156-3.134 7.094-2.066 2.066-4.536 3.1-7.456 3.1l-.379-.007c-2.01-.065-3.857-.65-5.506-1.79-1.797-1.213-3.1-2.786-3.908-4.762l-.144-.35c-.729-1.87-.863-3.817-.44-5.804.404-2.11 1.392-3.908 2.875-5.39l.272-.264a10.36 10.36 0 0 1 5.208-2.656Zm2.022 14.731c-1.5 0-3.328.417-5.437 1.31l.328 1.19.399-.161c1.846-.726 3.444-1.088 4.756-1.088 1.36 0 3.047.416 5.063 1.25l.328-1.191c-2.11-.893-3.937-1.31-5.437-1.31ZM8.188 10v2.516c0 .246.094.492.281.689a.906.906 0 0 0 .657.295c.28 0 .514-.099.702-.295a.993.993 0 0 0 .282-.689V10.5L8.188 10Zm8.624 0-1.922.5v2.016c0 .246.094.492.282.689a.932.932 0 0 0 1.359 0 .996.996 0 0 0 .281-.689V10Z'
  />
);

export const viewBox = '0 0 25 25';
